export interface Location {
  city: string
  role: string
  isPrimary: boolean
  address: string[]
  phoneDisplay: string
  phoneHref: string
  directionsUrl?: string
}

export const locations: Location[] = [
  {
    city: 'Howell',
    role: 'Showroom & Auto Glass Service Center',
    isPrimary: true,
    address: ['222 W Grand River Ave', 'Howell, MI 48843'],
    phoneDisplay: '517-545-7772',
    phoneHref: 'tel:+15175457772',
    directionsUrl:
      'https://maps.google.com/?q=222+W+Grand+River+Ave+Howell+MI+48843',
  },
  {
    city: 'Ann Arbor',
    role: 'Satellite office',
    isPrimary: false,
    address: ['2723 South State St, Suite 150', 'Ann Arbor, MI 48104'],
    phoneDisplay: '734-887-6556',
    phoneHref: 'tel:+17348876556',
  },
  {
    city: 'Novi',
    role: 'Satellite office',
    isPrimary: false,
    address: ['39555 Orchard Hill Place, Suite 600', 'Novi, MI 48375'],
    phoneDisplay: '248-924-9899',
    phoneHref: 'tel:+12489249899',
  },
]

export const hours: { day: string; time: string }[] = [
  { day: 'Monday – Friday', time: '8:00am – 5:00pm' },
  { day: 'Saturday', time: '9:00am – 3:00pm' },
  { day: 'Sunday', time: 'Closed' },
]

export const primaryServiceArea =
  'Southeast Michigan, including Howell, Ann Arbor, Novi, Brighton, Hartland, Fenton, Fowlerville, Northville and nearby communities.'

export const additionalServiceAreas = [
  'Lansing',
  'East Lansing',
  'Grand Blanc',
  'Webberville',
  'Williamston',
  'Livonia',
  'Milford',
  'Pinckney',
  'Whitmore Lake',
  'Wixom',
]

